<template>
  <div>
    <vx-card class="mb-4" v-if="information">
      <div class="flex justify-between mb-3">
        <div class="flex items-center">
          <div class="h-10 w-10 flex justify-center items-center rounded-lg mr-3 "
               :style="`background: #${color}`">
            <feather-icon icon="InfoIcon" svgClasses="h-6 w-6"/>
          </div>
          <h3 class="font-bold">Information</h3>
        </div>
      </div>
      <div v-html="information"/>
    </vx-card>

    <vx-card class="mb-4 cursor-pointer" @click="updateTab(2)">
      <div class="flex justify-between">
        <div class="flex items-center">
          <div class="h-10 w-10 flex justify-center items-center rounded-lg mr-3 "
               :style="`background: #${color}`">
            <feather-icon icon="VideoIcon" svgClasses="h-6 w-6"/>
          </div>
          <h3 class="font-bold">Meetings</h3>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  name: 'ClassroomStreamSidebar',
  props: {
    information: {
      type: String
    },
    color: {
      type: String
    }
  },
  methods: {
    updateTab (id) {
      this.$emit('updateTab', id)
    }
  }
}
</script>

<style scoped>

</style>
